module.exports = __webpack_public_path__ + "d3521d0fff004f9a65fd2a46b7f5f27c.MP3";